import { render } from "./SearchablesFooter.vue?vue&type=template&id=5c7ecba4"
import script from "./SearchablesFooter.vue?vue&type=script&lang=js"
export * from "./SearchablesFooter.vue?vue&type=script&lang=js"

import "./SearchablesFooter.vue?vue&type=style&index=0&id=5c7ecba4&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__